import { takeLatest } from "redux-saga/effects"

import * as services from "./services"
import Creators, { UsersTypes as constants } from "./reducer"
import { getStatisticsAdmin } from "../BusinessAccountsPage/redux/businessAccounts.thunks"

import { apiGeneratorBase, apiGeneratorBaseWithOnSuccess, apiGeneratorDelete, apiGeneratorDeleteWithOnSuccess } from "../../Utils/saga"

const actions = {
  getUsersFilterOptionsActions: {
    request: Creators.getUsersFilterOptionsRequest,
    success: Creators.getUsersFilterOptionsSuccess,
    errors: Creators.getUsersFilterOptionsFailure
  },
  getUsersActions: {
    request: Creators.getUsersRequest,
    success: Creators.getUsersSuccess,
    errors: Creators.usersFailure
  },
  deleteUserActions: {
    request: Creators.deleteUserRequest,
    success: Creators.deleteUserSuccess,
    errors: Creators.usersFailure,
    extraAction: [getStatisticsAdmin]
  },
  getUsersExportActions: {
    request: Creators.getUsersExportRequest,
    success: Creators.getUsersExportSuccess,
    errors: Creators.getUsersExportFailure
    //downloadFile: true,
  },
  giftActions: {
    request: Creators.giftRequest,
    success: Creators.giftSuccess,
    errors: Creators.usersFailure
  },
  withdrawActions: {
    request: Creators.withdrawRequest,
    success: Creators.withdrawSuccess,
    errors: Creators.usersFailure
  },
  switchToLoyalBillingActions: {
    request: Creators.switchToLoyalBillingRequest,
    success: Creators.switchToLoyalBillingSuccess,
    errors: Creators.usersFailure
  },
  saveCommentActions: {
    request: Creators.saveCommentRequest,
    success: Creators.saveCommentSuccess,
    errors: Creators.usersFailure,
  },
  getUserInfoCommentActions: {
    request: Creators.getUserInfoCommentRequest,
    success: Creators.getUserInfoCommentSuccess,
    errors: Creators.usersFailure,
  },
  getUserBusinessAccountsListActions: {
    request: Creators.getUserBusinessAccountsListRequest,
    success: Creators.getUserBusinessAccountsListSuccess,
    errors: Creators.usersFailure,
  },
  getUserCommentActions: {
    request: Creators.getUserCommentRequest,
    success: Creators.getUserCommentSuccess,
    errors: Creators.usersFailure,
  },
  deleteUserCommentActions: {
    request: Creators.deleteUserCommentRequest,
    success: Creators.deleteUserCommentSuccess,
    errors: Creators.usersFailure,
  },
  deleteUserCommentAttachmentActions: {
    request: Creators.deleteUserCommentAttachmentRequest,
    success: Creators.deleteUserCommentAttachmentSuccess,
    errors: Creators.usersFailure,
  },
}

const eventsOptions = {
  [constants.GET_USERS_FILTER_OPTIONS_REQUEST]: {
    api: services.getUsersFilterOptions,
    actions: actions.getUsersFilterOptionsActions
  },
  [constants.GET_USERS_REQUEST]: {
    api: services.getUsers,
    actions: actions.getUsersActions
  },
  [constants.DELETE_USER_REQUEST]: {
    api: services.deleteUser,
    actions: actions.deleteUserActions
  },
  [constants.GET_USERS_EXPORT_REQUEST]: {
    api: services.getUsersExport,
    actions: actions.getUsersExportActions
  },
  [constants.GIFT_REQUEST]: {
    api: services.sendGift,
    actions: actions.giftActions
  },
  [constants.WITHDRAW_REQUEST]: {
    api: services.withDraw,
    actions: actions.withdrawActions
  },
  [constants.SWITCH_TO_LOYAL_BILLING_REQUEST]: {
    api: services.switchUserToLoyalBilling,
    actions: actions.switchToLoyalBillingActions
  },
  [constants.GET_USER_INFO_COMMENT_REQUEST]: {
    api: services.getUserInfoComment,
    actions: actions.getUserInfoCommentActions,
  },
  [constants.GET_USER_BUSINESS_ACCOUNTS_LIST_REQUEST]: {
    api: services.getUserBusinessAccountsList,
    actions: actions.getUserBusinessAccountsListActions,
  },
  [constants.GET_USER_COMMENT_REQUEST]: {
    api: services.getUserComment,
    actions: actions.getUserCommentActions,
  },
  [constants.SAVE_COMMENT_REQUEST]: {
    api: services.saveComment,
    actions: actions.saveCommentActions,
  },
  [constants.DELETE_USER_COMMENT_REQUEST]: {
    api: services.deleteUserComment,
    actions: actions.deleteUserCommentActions,
  },
  [constants.DELETE_USER_COMMENT_ATTACHMENT_REQUEST]: {
    api: services.deleteUserCommentAttachment,
    actions: actions.deleteUserCommentAttachmentActions,
  },
}

export default function* apiSaga() {
  yield takeLatest(constants.GET_USERS_FILTER_OPTIONS_REQUEST, (action)=> apiGeneratorBase(action, eventsOptions[constants.GET_USERS_FILTER_OPTIONS_REQUEST]));
  yield takeLatest(constants.GET_USERS_REQUEST, (action)=> apiGeneratorBase(action, eventsOptions[constants.GET_USERS_REQUEST]));
  yield takeLatest(constants.GET_USERS_EXPORT_REQUEST, (action)=> apiGeneratorBase(action, eventsOptions[constants.GET_USERS_EXPORT_REQUEST]));
  yield takeLatest(constants.DELETE_USER_REQUEST, (action)=> apiGeneratorDelete(action, eventsOptions[constants.DELETE_USER_REQUEST]));
  yield takeLatest(constants.GIFT_REQUEST, (action)=> apiGeneratorBase(action, eventsOptions[constants.GIFT_REQUEST]));
  yield takeLatest(constants.WITHDRAW_REQUEST, (action)=> apiGeneratorBase(action, eventsOptions[constants.WITHDRAW_REQUEST]));
  yield takeLatest(constants.SWITCH_TO_LOYAL_BILLING_REQUEST, (action)=> apiGeneratorBase(action, eventsOptions[constants.SWITCH_TO_LOYAL_BILLING_REQUEST]));
  yield takeLatest(constants.GET_USER_INFO_COMMENT_REQUEST, (action)=> apiGeneratorBaseWithOnSuccess(action, eventsOptions[constants.GET_USER_INFO_COMMENT_REQUEST]));
  yield takeLatest(constants.GET_USER_BUSINESS_ACCOUNTS_LIST_REQUEST, (action)=> apiGeneratorBaseWithOnSuccess(action, eventsOptions[constants.GET_USER_BUSINESS_ACCOUNTS_LIST_REQUEST]));
  yield takeLatest(constants.GET_USER_COMMENT_REQUEST, (action)=> apiGeneratorBaseWithOnSuccess(action, eventsOptions[constants.GET_USER_COMMENT_REQUEST]));
  yield takeLatest(constants.SAVE_COMMENT_REQUEST, (action)=> apiGeneratorBaseWithOnSuccess(action, eventsOptions[constants.SAVE_COMMENT_REQUEST]));
  yield takeLatest(constants.DELETE_USER_COMMENT_REQUEST, (action)=> apiGeneratorDeleteWithOnSuccess(action, eventsOptions[constants.DELETE_USER_COMMENT_REQUEST]));
  yield takeLatest(constants.DELETE_USER_COMMENT_ATTACHMENT_REQUEST, (action)=> apiGeneratorDeleteWithOnSuccess(action, eventsOptions[constants.DELETE_USER_COMMENT_ATTACHMENT_REQUEST]));
}
